import React, {Component} from "react";
import {Link} from 'react-router-dom';

/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setPage } from "../../../store/actions/FormAction";

/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();
/*
    Documents view that displays the Document Uploader page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
    SVGs need to have the xml attributes removed
*/
class ChangePassword extends Component {

  componentDidMount() {
    this.props.updateForm("pagename", "Change Password");
    this.props.setPage("changepassword");

    this.props.updateForm("currentpwd", "");
    this.props.updateForm("newpwd", "");

    //For Testing Purposes
    if (this.props.st.length < 1){
      this.props.updateForm("fn", "John");
      this.props.updateForm("ln", "Doe");
      this.props.updateForm("address", "123 Main St, Columbus, OH, 34567");
      this.props.updateForm("street", "123 Main St");
      this.props.updateForm("city", "Columbus");
      this.props.updateForm("st", "Ohio");
      this.props.updateForm("stt", "OH");
      this.props.updateForm("zip", "34567");
      this.props.updateForm("eml", "jonathandoe@johndoeacct.com");
      this.props.updateForm("phn", "512-321-4567");
      this.props.updateForm("ismobile", true);
      this.props.updateForm("ssn", "XXX-XX-1234");
      this.props.updateForm("co", "ABCD Co");
      this.props.updateForm("cophn", "412-321-4567");
      this.props.updateForm("payfrequency", "Bi-Weekly");
      this.props.updateForm("payamount", "1643.56");
      this.props.updateForm("accounttype", "Checking");
      this.props.updateForm("bankaccount", "81214654564");
      this.props.updateForm("routingnum", "012100564");
      this.props.updateForm("sig1", "1234");
      this.props.updateForm("sig2", "1234");
      this.props.updateForm("sig3", "1234");
      this.props.updateForm("ref1fn", "Mary");
      this.props.updateForm("ref1ln", "Doe");
      this.props.updateForm("ref1phn", "512-321-4567");
      this.props.updateForm("ref1rel", "Sister");
      this.props.updateForm("ref2fn", "Jenny");
      this.props.updateForm("ref2ln", "Appleseed");
      this.props.updateForm("ref2phn", "312-555-4863");
      this.props.updateForm("ref2rel", "Cousin");
    }
  }

  handlePasswordChange(e) {
    let password = e.target.value;
    this.props.updateForm("currentpwd", password);

    let pwdtip = document.getElementById("pwdtip");
    const passlabel = document.querySelector("label[for='pwd']");

    //TODO: change to check match of password
    if (password.length >= 8) {
      this.passwordchecked = true;
      pwdtip.innerHTML = "";
      pwdtip.classList.add("hidden");
      passlabel.classList.add("activepass");
    } else {
      this.passwordchecked = false;
      passlabel.classList.remove("activepass");
    }

    this.props.updateForm("allchecked", validation.checkAll([true,this.passwordchecked,this.econsentchecked]));
  }

  handlePasswordBlur(e) {
    let password = e.target.value;
    let pwdtip = document.getElementById("pwdtip");
    const passlabel = document.querySelector("label[for='pwd']");

    if (password.length < 8){
      pwdtip.innerHTML = "Your password needs to be at least 8 characters.";
      pwdtip.classList.remove("hidden");
      passlabel.classList.remove("activepass");
    } else if (!validation.validatePass(password)) {
      pwdtip.innerHTML = "Try adding a special character and/or number.";
      pwdtip.classList.remove("hidden");
      passlabel.classList.remove("activepass");
    }
  }

  handlePasswordChange2(e) {
    let password = e.target.value;
    this.props.updateForm("newpwd", password);

    let pwdtip = document.getElementById("newpwdtip");
    const passlabel = document.querySelector("label[for='newpwd']");

    if (password.length >= 8 && validation.validatePass(password)) {
      this.passwordchecked = true;
      pwdtip.innerHTML = "";
      pwdtip.classList.add("hidden");
      passlabel.classList.add("activepass");
    } else {
      this.passwordchecked = false;
      passlabel.classList.remove("activepass");
    }

    this.props.updateForm("allchecked", validation.checkAll([true,this.passwordchecked,this.econsentchecked]));
  }

  handlePasswordBlur2(e) {
    let password = e.target.value;
    let pwdtip = document.getElementById("newpwdtip");
    const passlabel = document.querySelector("label[for='newpwd']");

    if (password.length < 8){
      pwdtip.innerHTML = "Your password needs to be at least 8 characters.";
      pwdtip.classList.remove("hidden");
      passlabel.classList.remove("activepass");
    } else if (!validation.validatePass(password)) {
      pwdtip.innerHTML = "Try adding a special character and/or number.";
      pwdtip.classList.remove("hidden");
      passlabel.classList.remove("activepass");
    }
  }

  handleEyeClick(e){
    e.preventDefault();
    var x = document.getElementById("pwd");
    if (x.type === "password") {
        x.type = "text";
    } else {
        x.type = "password";
    }
  }

  handleEyeClick2(e){
    e.preventDefault();
    var x = document.getElementById("newpwd");
    if (x.type === "password") {
        x.type = "text";
    } else {
        x.type = "password";
    }
  }

  render() {

      return (
          <div id="dashboard2">
            <div className="dashheader">
              {this.props.pagename}
            </div>
            <div className="container text-center">
              <p className="buttontitle">Change Your Password</p>
              <form className="flowform padtop30">
                  <div className="form-group">
                      <label htmlFor="pwd">
                          Current password
                          <input type="password" name="pwd" id="pwd" className="form-control" tabIndex="1" value={this.props.currentpwd} onChange={this.handlePasswordChange} onBlur={this.handlePasswordBlur} />
                          <a className="allseeing" onClick={this.handleEyeClick} >
                            <svg width="20px" viewBox="0 0 20 13">
                                <g stroke="none" strokeWidth="1" transform="translate(-260.000000, -406.000000) translate(260.000000, 406.000000)" fill="#7F868A" fillRule="nonzero">
                                    <path d="M10.0001136,0 C5.21617662,0 1.19200936,2.75570577 0,6.5 C1.19200936,10.2445411 5.21640376,13 9.99988643,13 C14.7838234,13 18.8079906,10.2442942 20,6.5 C18.8079906,2.75545893 14.7838234,0 10.0001136,0 Z M10.0755227,11.0924315 C7.70240651,11.0924315 5.77879232,9.00195572 5.77879232,6.42298637 C5.77879232,3.84401701 7.70240651,1.75354118 10.0755227,1.75354118 C12.4484118,1.75354118 14.3722531,3.84401701 14.3722531,6.42298637 C14.3722531,9.00195572 12.4484118,11.0924315 10.0755227,11.0924315 Z" id="Shape"></path>
                                </g>
                            </svg>
                          </a>
                      </label>
                  </div>
                  <div className="form-group">
                      <label htmlFor="newpwd">
                          New password
                          <div className="errortip hidden" id="newpwdtip">
                              Try adding a number or special character.
                          </div>
                          <input type="password" name="newpwd" id="newpwd" className="form-control" tabIndex="2" value={this.props.newpwd} onChange={this.handlePasswordChange2} onBlur={this.handlePasswordBlur2} />
                          <a className="allseeing" onClick={this.handleEyeClick2} >
                            <svg width="20px" viewBox="0 0 20 13">
                                <g stroke="none" strokeWidth="1" transform="translate(-260.000000, -406.000000) translate(260.000000, 406.000000)" fill="#7F868A" fillRule="nonzero">
                                    <path d="M10.0001136,0 C5.21617662,0 1.19200936,2.75570577 0,6.5 C1.19200936,10.2445411 5.21640376,13 9.99988643,13 C14.7838234,13 18.8079906,10.2442942 20,6.5 C18.8079906,2.75545893 14.7838234,0 10.0001136,0 Z M10.0755227,11.0924315 C7.70240651,11.0924315 5.77879232,9.00195572 5.77879232,6.42298637 C5.77879232,3.84401701 7.70240651,1.75354118 10.0755227,1.75354118 C12.4484118,1.75354118 14.3722531,3.84401701 14.3722531,6.42298637 C14.3722531,9.00195572 12.4484118,11.0924315 10.0755227,11.0924315 Z" id="Shape"></path>
                                </g>
                            </svg>
                          </a> <div className="nothuman"><input type="password" name="password" /></div>
                      </label>
                      <div className="hint animated popIn" id="pwdhint">
                          At least 8 characters with one letter, number or special character
                      </div>
                  </div>

                  <Link to="/dashboard/viewprofile" className="btn last-step padtop">Submit</Link>
              </form>
            </div>
          </div>
        );
    }
}

const mapStateToProps = (state) => ({
    st: state.FormReducer.st,
    page: state.FormReducer.page,
    pagename: state.FormReducer.pagename,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setPage: (page) => dispatch(setPage(page))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/ChangePassword.js